var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCustomStrokeLg = function SvgIconCustomStrokeLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 10h26v26H11z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    strokeWidth: 2,
    d: "M11 10h26v26H11z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    strokeWidth: 2,
    d: "M20 23v13h8V23h-8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    strokeWidth: 2,
    d: "M7 36h34"
  }));
};
export default SvgIconCustomStrokeLg;